import CarRent from '../Assets/Products/admin-dashboard_kk8oxo.png'

const Products = [
  {
    name: "Car Rental Management System",
    TechStack: {
      frontend: ["Blade Templates", "Livewire", "Tailwind CSS", "Alpine.js"],
      Db: ["MySql"],
      Backend: ["PHP Laravel"],
      Authentication: ["Role-based login system (Admin, Manager, Customer)"],
    },
    image: CarRent ,
    popular:true,
  },
//   {
//     name: "Car Rental Management System",
//     TechStack: {
//       frontend: ["Blade Templates", "Livewire", "Tailwind CSS", "Alpine.js"],
//       Db: ["MySql"],
//       Backend: ["PHP Laravel"],
//       Authentication: ["Role-based login system (Admin, Manager, Customer)"],
//     },
//     image: "https://res.cloudinary.com/dtfrsnzzt/image/upload/v1755211021/admin-dashboard_kk8oxo.png",
//   },
];

export default Products;
